import type { School } from "./school";

export type SchoolDay = {
  id: number | null;
  days: string[];
  school: School;
  class_name: string;
  school_id?: string;
};

export const emptySchoolDay = {
  class_name: "",
  days: [],
  id: null,
} satisfies Omit<SchoolDay, "school">;
